import React from "react";
import { string, number } from "prop-types";
import { WithContext as ReactTags } from "react-tag-input";
import Button from "pages/_components/Button";
import { useTags } from "pages/payThirdParties/hooks/useTags";

const ReactTagWithoutInput = ({ optionThirdParty, positionTab }) => {
    const { tags, handleDelete, handleCleanFilters } = useTags(optionThirdParty, positionTab);

    if (!tags.length) {
        return null;
    }

    return (
        <>
            <ReactTags
                autofocus={false}
                tags={tags}
                handleDelete={handleDelete}
                allowDragDrop={false}
                placeholder=""
                inputProps={{
                    disabled: true,
                    autocomplete: "off",
                }}
                classNames={{
                    tags: "tagsClass",
                    selected: "selectedClass",
                    tag: "tagClass",
                    remove: "removeClass",
                }}
            />

            <Button
                image="images/figma/icon/clear-filter.svg"
                onClick={handleCleanFilters}
                label="debin.clean.filters"
                className="btn btn-link clear-filters"
                block={false}
                icon=""
            />
        </>
    );
};

ReactTagWithoutInput.propTypes = {
    optionThirdParty: string.isRequired,
    positionTab: number.isRequired,
};

export default ReactTagWithoutInput;
